import type {
  CreateRegistrationRequestBody,
  RegistrationSubmissionReceipt,
} from '@parinaam-vms/shared';
import { apiGet, apiPost } from './client';

/** A mandatory-training document the public form links to (registration spec). */
export interface TrainingMaterial {
  label: string;
  url: string;
}

/**
 * `GET /registration-requests/training-materials` — the public, non-sensitive
 * list of training documents. The one read the public page makes that returns no
 * volunteer data, which is why it is allowed on the public surface.
 */
export function fetchTrainingMaterials(): Promise<TrainingMaterial[]> {
  return apiGet<TrainingMaterial[]>('/registration-requests/training-materials');
}

/**
 * `POST /registration-requests` — the public intake (§1.7).
 *
 * The only call the public page makes, and the only call in the frontend that
 * does not need a member of staff behind it. It returns a message and nothing
 * else: there is no companion `fetch` here on purpose, because a public page that
 * can read registrations back is the leak Plan Section 5 exists to prevent. Staff
 * reads live in `registrations.ts` (M1 track D2), behind the staff shell.
 */
export function submitRegistration(
  body: CreateRegistrationRequestBody
): Promise<RegistrationSubmissionReceipt> {
  return apiPost<RegistrationSubmissionReceipt>('/registration-requests', body);
}
